/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actions used to manipulate application state
import { requestStoryResponseResult, advanceFrame } from 'redux/actions/content_status';

// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import Story from 'components/content/shared/story/story';


/* ========== ~~~~~~~~~~ SPLASH SCREEN: PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ contentStatus, settings, sessionStatus }, { contentId, storyData }) => ({
    currentContentStatus: contentStatus[contentId],
    currentContentSettings: settings.contentSettings[contentId],
    userInfo: sessionStatus.userInfo,
    embedUUID: settings.embedSettings.embedUUID,
    embedSettings: settings.embedSettings,
    settings: settings,
    frameData: storyData,
    frameStatus: storyData.frameStatus[storyData.frame],
    isPubPortalPreview: settings.embedSettings.isPubPortalPreview,
    enlargedFont: settings.embedSettings.enlargedFont

});

// map actions
const mapDispatchToProps = dispatch => ({
    advanceFrame: contentId => dispatch(advanceFrame(contentId)),
    requestStoryResponseResult: (contentId, frame, isFactualQuestion, responseDetails, isPubPortalPreview) => dispatch(requestStoryResponseResult(contentId, frame, isFactualQuestion, responseDetails, isPubPortalPreview))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Story);
